import { authHeader, handleResponse } from './helper';
import config from '../config';
import { getCookie } from './cookies';

export const sendOrderToBiartic = async (params) => {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
      branchOfficeId: getCookie('branch_office_id'),
    },
    body: JSON.stringify(params)
  };
  const url = new URL(`${config.apiOptometryBiarticUrl}/order/sendOrder`);
  return await fetch(url, requestOptions).then(handleResponse);
}

export const getOrderFromBiartic = async (params) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
      branchOfficeId: getCookie('branch_office_id'),
    },
  };
  const url = new URL(`${config.apiOptometryBiarticUrl}/order/getOrder`);
  if (params) {
    Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
  }
  return await fetch(url, requestOptions).then(handleResponse);
}

export const optometryService = {
  sendOrderToBiartic,
  getOrderFromBiartic,
};
